// ClientLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { clientApi, saveClientSession } from "./clientApi";

// TODO: fix this import path to match wherever your logo actually lives -
// copy the exact import line from Header.jsx and paste it here instead.
import eilanLogo from "../../Assets/Images/eilanlogo.png";

import "./ClientLogin.css";

const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);

const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="11" width="16" height="9" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

const EyeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.3 20.3 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a20.3 20.3 0 0 1-2.16 3.19" />
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

export default function ClientLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await clientApi.login(username.trim(), password);
      saveClientSession(result.token, result.expiresAt);
      navigate("/gallery");
    } catch (err) {
      if (err.code === "ACCOUNT_EXPIRED") {
        setError(err.message);
      } else {
        setError("Invalid username or password.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="client-login-page">
      <div className="client-login-card">
        <svg
          className="client-login-shapes"
          width="144"
          height="144"
          viewBox="0 0 144 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M72 0V72H36C16.13 72 0 55.87 0 36V0L72 0Z" fill="#E99000" />
          <path d="M72 108V72H144V144H108C88.13 144 72 127.87 72 108Z" fill="#41694F" />
        </svg>

        <img src={eilanLogo} alt="Eilan Digital" className="client-login-logo" />

        <p className="client-login-message">
          We're here to turn your ideas into high-impact digital experiences.
          Let's discuss how we can move your brand forward today.
        </p>

        <form onSubmit={handleSubmit}>
          <label className="client-login-label" htmlFor="client-username">
            Username
          </label>
          <div className="client-login-field">
            <span className="client-login-field-icon"><UserIcon /></span>
            <input
              id="client-username"
              className="client-login-input"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>

          <label className="client-login-label" htmlFor="client-password">
            Password
          </label>
          <div className="client-login-field">
            <span className="client-login-field-icon"><LockIcon /></span>
            <input
              id="client-password"
              className="client-login-input"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="client-login-password-toggle"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          </div>

          {error && <div className="client-login-error">{error}</div>}

          <button className="client-login-button" type="submit" disabled={loading}>
            {loading ? "Signing in…" : "View Portfolio"}
          </button>
        </form>
      </div>
    </div>
  );
}